import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';



import queryString from 'query-string';



import BaseFilter, { FilterTypeEnum } from 'components/base/BaseFilter';
import { COUPON_SET_MEDIUM } from 'config/CustomEnums';



import { ArrayStringData, getHashKeyString } from 'utils';


function Filter({ campaignList, earningRuleList, couponSetList, transactionList, backAction = () => { } }) {
  const location = useLocation();
  const activeTab = getHashKeyString(location.hash) || 'Records';

  const parsedSearch = queryString.parse(location.search);
  const searchRecordScope = parsedSearch['record_scope'] || '';
  const searchRecordType = parsedSearch['record_type'] || '';
  const searchCouponMedium = parsedSearch['coupon_medium'] || '';
  const searchExpiredDateType = parsedSearch['expired_date'] || '';
  const searchAbsoluteDate = parsedSearch['absolute'] || '';
  const searchRelativeDay = parsedSearch['relativeDay'] || '';
  const searchCreationDate = parsedSearch['creation_date'] || '';
  const searchPurchaseDate = parsedSearch['purchase_date'] || '';
  const searchCampaigns = ArrayStringData(parsedSearch['campaigns'] || "");
  const searchEarningRules = ArrayStringData(parsedSearch['earning_rules'] || "");
  const searchCouponSets = ArrayStringData(parsedSearch['coupon_sets'] || "");
  const searchTimeRange = parsedSearch['time_range'] || '';
  const searchReportType = parsedSearch['report_type'] || '';
  const searchTransactions = ArrayStringData(
    parsedSearch['transaction'] || '',
  );

  const [recordScope, setRecordScope] = useState(searchRecordScope);
  const [recordType, setRecordType] = useState(
    ArrayStringData(searchRecordType),
  );
  const [couponMedium, setCouponMedium] = useState(ArrayStringData(searchCouponMedium));
  const [expiredDateType, setExpiredDateType] = useState(searchExpiredDateType);
  const [absoluteDate, setAbsoluteDate] = useState(searchAbsoluteDate);
  const [relativeDay, setRelativeDay] = useState(searchRelativeDay);
  const [creationDate, setCreationDate] = useState(searchCreationDate);
  const [purchaseDate, setPurchaseDate] = useState(searchPurchaseDate);
  const [targetCampaigns, setTargetCampaigns] = useState([]);
  const [targetEarningRules, setTargetEarningRules] = useState([]);
  const [targetCouponSets, setTargetCouponSets] = useState([]);
  const [reportsTimeRange, setReportsTimeRange] = useState(searchTimeRange);
  const [reportType, setReportType] = useState(searchReportType);
  const [targetTransaction, setTargetTransaction] = useState([]);

  useEffect(() => {
    if (activeTab !== "Records") {
      return;
    }
    if (searchCampaigns && campaignList) {
      let checkedCampaigns = []
      searchCampaigns.forEach((item, index) => {
        const checkedSingeCampaign = campaignList.find(
          (value) => value?.pk === item,
        );
        if (checkedSingeCampaign) {
          checkedCampaigns.push({
            label: `[ID: ${checkedSingeCampaign?.pk}] ${checkedSingeCampaign?.name}`,
            value: checkedSingeCampaign,
          });
        }
      });
      setTargetCampaigns(checkedCampaigns);
    }
    if (searchEarningRules && earningRuleList) {
      let checkedEarningRules = []
      searchEarningRules.forEach((item, index) => {
        const checkedSingeEarningRule = earningRuleList.find(value => value?.pk === item)
        if (checkedSingeEarningRule) {
          checkedEarningRules.push({
            label: `[ID: ${checkedSingeEarningRule?.pk}] ${checkedSingeEarningRule?.name}`,
            value: checkedSingeEarningRule
          })
        }
      })
      setTargetEarningRules(checkedEarningRules);
    }
    if (searchCouponSets && couponSetList) {
      let checkedCouponSets = [];
      searchCouponSets.forEach((item, index) => {
        const checkedSingeCouponSet = couponSetList.find(value => value?.pk === item);
        if (checkedSingeCouponSet) {
          checkedCouponSets.push({
            label: `[ID: ${checkedSingeCouponSet?.pk}] ${checkedSingeCouponSet?.name}`,
            value: checkedSingeCouponSet,
          })
        }
      });
      setTargetCouponSets(checkedCouponSets);
    }
    if (searchTransactions && transactionList) {
      let checkedTransactions = [];
      searchTransactions.forEach((item, index) => {
        const checkedSingeTransaction = transactionList.find(
          (value) => value?.pk === item,
        );
        if (checkedSingeTransaction) {
          checkedTransactions.push({
            label: `[ID: ${checkedSingeTransaction?.pk}] ${checkedSingeTransaction?.name}`,
            value: checkedSingeTransaction,
          });
        }
      });
      setTargetTransaction(checkedTransactions);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let content;
  if (activeTab === "Reports") {
    content = [
      {
        title: 'Report type',
        data: [
          { pk: 'WEEKLY', name: 'Weekly report' },
          { pk: 'MONTHLY', name: 'Monthly report' },
        ],
        value: reportType,
        setValue: setReportType,
        component: FilterTypeEnum.singleChoice,
        className: 'fit-content-height-area',
      },
      {
        title: 'Time range',
        value: reportsTimeRange,
        setValue: setReportsTimeRange,
        component: FilterTypeEnum.dateRange,
      },
    ]
  } else {
    content = [
      {
        title: 'Record scope',
        data: [
          { pk: 'REWARDED_RECORDS', name: 'Rewarded records' },
          { pk: 'NON_REWARDED_RECORDS', name: 'Non-rewarded records' },
        ],
        value: recordScope,
        setValue: setRecordScope,
        component: FilterTypeEnum.singleChoice,
        className: 'fit-content-height-area',
      },
      {
        title: 'Record type',
        data: [
          { name: 'Customer earned', pk: 'EARN' },
          { name: 'Customer acquired', pk: 'BUY' },
          { name: 'Admin added', pk: 'GRANT' },
          { name: 'Admin removed', pk: 'RECLAIM' },
          { name: 'Merchant added', pk: 'MERCHANT_GRANT' },
          { name: 'Merchant removed', pk: 'MERCHANT_RECLAIM' },
          { name: 'Customer used', pk: 'USE' },
          { name: 'Admin used', pk: 'ADMIN_USE' },
          { name: 'Merchant used', pk: 'MERCHANT_USE' },
          { name: 'Coupon expired', pk: 'EXPIRED' },
          { name: 'Admin deactivated', pk: 'DEACTIVATE' },
          { name: 'Admin reactivated', pk: 'REACTIVATE' },
          { name: 'Return', pk: 'RETURN' },
        ],
        value: recordType,
        setValue: setRecordType,
        component: FilterTypeEnum.choice,
      },
      {
        title: 'Coupon medium',
        data: [
          { name: 'Online only', pk: COUPON_SET_MEDIUM.ONLINE },
          { name: 'Offline only', pk: COUPON_SET_MEDIUM.OFFLINE },
          { name: 'Online or offline', pk: COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE },
        ],
        value: couponMedium,
        setValue: setCouponMedium,
        component: FilterTypeEnum.choice,
        className: 'fit-content-height-area',
      },
      {
        title: 'Expired date',
        data: [
          { name: 'All time', pk: 'allTime', subComponment: null },
          {
            name: 'Time Range',
            pk: 'absolute',
            subComponment: {
              value: absoluteDate,
              setValue: setAbsoluteDate,
              component: FilterTypeEnum.dateRange,
            },
          },
          {
            name: 'Since acquiring',
            pk: 'relativeDay',
            subComponment: {
              value: relativeDay,
              setValue: setRelativeDay,
              component: FilterTypeEnum.input,
            },
          },
        ],
        value: expiredDateType,
        setValue: setExpiredDateType,
        component: FilterTypeEnum.singleChoice,
      },
      {
        title: 'Purchase date',
        value: purchaseDate,
        setValue: setPurchaseDate,
        component: FilterTypeEnum.dateRange,
      },
      {
        title: 'Creation date',
        value: creationDate,
        setValue: setCreationDate,
        component: FilterTypeEnum.dateRange,
      },
      { 
        filterTitle: 'Campaigns',
        data: campaignList,
        value: targetCampaigns,
        setValue: setTargetCampaigns,
        placeholder: 'Search by campaign ID and name',
        loadMoreAction: 'campaignList/getCampaignList',
        filterAction: 'campaignList/getCampaignList',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        defaultFilter: {
          isSimpleList: true,
          isAvailable: false,
          noLoading: true,
          searchNameOrId: true,
        },
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
      { 
        filterTitle: 'Earning Rules',
        data: earningRuleList,
        value: targetEarningRules,
        setValue: setTargetEarningRules,
        placeholder: 'Search by earning rule ID and name',
        loadMoreAction: 'earningRuleList/getSimpleEarningRuleListForSelector',
        filterAction: 'earningRuleList/getSimpleEarningRuleListForSelector',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        defaultFilter: {
          isSelectorLoad: true,
        },
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
      { 
        filterTitle: 'Coupon sets',
        data: couponSetList,
        value: targetCouponSets,
        setValue: setTargetCouponSets,
        placeholder: 'Search by coupon set ID and name',
        loadMoreAction: 'couponList/getSimpleCouponSetListForSelector',
        filterAction: 'couponList/getSimpleCouponSetListForSelector',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        defaultFilter: {
        },
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
      {
        filterTitle: 'Transaction',
        data: transactionList,
        value: targetTransaction,
        setValue: setTargetTransaction,
        placeholder: 'Search by transaction ID',
        loadMoreAction: 'transactions/getSimpleTransactionsForSelector',
        filterAction: 'transactions/getSimpleTransactionsForSelector',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
    ]; 
  }


  return <BaseFilter content={content} backAction={backAction} />;
}
const mapPropsToState = (state) => ({
  campaignList: state.campaignList.allList,
  earningRuleList: state.earningRuleList.earningRuleList,
  couponSetList: state.couponList.couponTemplateList,
  transactionList: state.transactions.transactionList,
})
export default connect(mapPropsToState)(Filter);